<template>
  <section class="apartment-popUp">
    <el-row type="flex">
      <el-col :span="16" :xs="24">
        <ApartmentSlider :slides="item.images" :color="item.color" :sold_at="item.sold_at" />
      </el-col>

      <el-col :span="8" :xs="24">
        <div class="apartment-info-wrapper">
          <div class="mobile-apartment-block hidden-sm-and-up">
            <ApartmentPrise :id="item.id" :price="item.price" />
            <div class="apartment-socials-block">
              <AddToSelectedBtn
                @toggle-favorite="toggleFavorite"
                :active="!!favoriteFlats.find((el) => el.id === item.id)"
              />
              <ApartmentSocial
                :popper-horizontal="true"
                popper-direction="left"
                :id="item.id"
              />
              <ApartmentSocialMobile  :id="item.id"/>
            </div>
          </div>
          <div class="name-mobile-apartment hidden-sm-and-up">
            {{ item.rooms }} к - {{ item.district.name }}
          </div>
          <div class="apartment-info-content">
            <ApartmentInfo :item="item" :show-prise="true" />
            <div class="apartment-price-block hidden-xs-only">
              <AddToSelectedBtn
                :active="!!favoriteFlats.find((el) => el.id === item.id)"
                @toggle-favorite="toggleFavorite"
              />
              <ApartmentSocial
                :popper-horizontal="false"
                popper-direction="bottom"
                :id="item.id"
              />
            </div>
          </div>

          <div
            class="apartment-description-wrapper mobile-apartment-description"
            v-if="currentFlat"
          >
            <h2 class="apartment-description-title">Опис</h2>
            <p class="apartment-description-text">
              {{ currentFlat.description }}
            </p>
          </div>
          <hr class="solid hidden-sm-and-up" />
          <div class="apartment-seller-wrapper" v-if="item.realtor">
            <div class="apartment-seller-title">Контакти продавця :</div>
            <div class="apartment-seller-content">
              <div class="seller-info">
                <div class="seller-img">
                  <div class="seller-logo">
                    <img
                      :src="item.realtor.avatar"
                      alt=""
                      v-if="item.realtor.avatar"
                    />
                    <IconBase v-else height="30" icon-name="user" width="30">
                      <User />
                    </IconBase>
                  </div>
                </div>
                <div class="seller-personal-info">
                  <div class="seller-name">
                    {{ item.realtor.last_name }} {{ item.realtor.name }}
                  </div>
                  <div class="seller-phone">
                    <div class="seller-phone-icon">
                      <IconBase height="16" icon-name="Phone" width="16">
                        <Phone />
                      </IconBase>
                    </div>
                    <iframe name="hiddeniframe" style="visibility:hidden;width:0;height:0;"></iframe>
                    <div
                      class="seller-phone-number"
                      v-if="item.realtor && item.realtor.primary_phone"
                    >
                      <a
                        :href="`tel:${item.realtor.primary_phone}`"
                        target="hiddeniframe"
                        >{{
                          item.realtor.primary_phone.replace(
                            /^\s*([0-9]{3})\s*\-?([0-9]{3})\s*\-?([0-9]{2})\s*\-?([0-9]{2})$/,
                            '$1 $2 $3 $4'
                          )
                        }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="seller-socials-wrapper">
                <div class="seller-socials-text">Мої соц. мережі:</div>
                <div class="seller-socials-container">
                  <ul class="socials-container White-colored Big">
                    <li class="socials-item" v-if="item.realtor.viber">
                      <a
                        class="socials-item-icon-container"
                        target="_blank"
                        :href="`viber://chat?number=%2B38${item.realtor.viber}`"
                      >
                        <IconBase
                          height="16"
                          icon-name="ViberColored"
                          width="16"
                        >
                          <ViberColored />
                        </IconBase>
                      </a>
                    </li>
                    <li class="socials-item" v-if="item.realtor.telegram">
                      <a
                        class="socials-item-icon-container"
                        target="_blank"
                        :href="`https://telegram.im/@${item.realtor.telegram}`"
                      >
                        <IconBase
                          height="16"
                          icon-color="#0088CC"
                          icon-name="TelegramColored"
                          width="16"
                        >
                          <TelegramBlack />
                        </IconBase>
                      </a>
                    </li>
                    <li class="socials-item" v-if="item.realtor.facebook">
                      <a
                        class="socials-item-icon-container"
                        target="_blank"
                        :href="`https://www.messenger.com/t/${item.realtor.facebook}`"
                      >
                        <IconBase
                          height="16"
                          icon-color="#3B5999"
                          icon-name="FacebookColored"
                          width="16"
                        >
                          <FacebookBlack />
                        </IconBase>
                      </a>
                    </li>
                    <li class="socials-item" v-if="item.realtor.instagram">
                      <a
                        class="socials-item-icon-container"
                        target="_blank"
                        :href="`https://www.instagram.com/${item.realtor.instagram}`"
                      >
                        <IconBase
                          height="16"
                          icon-name="InstagramColored"
                          width="16"
                        >
                          <InstagramColored />
                        </IconBase>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="seller-second-number">
                <div class="seller-second-number-text">
                  Мій додатковий номер:
                </div>
                <div
                  class="seller-second-number-number"
                  v-if="item.realtor && item.realtor.additional_phone"
                >
                  <a
                    :href="`tel:${item.realtor.additional_phone}`"
                    target="hiddeniframe"
                    >{{
                      item.realtor.additional_phone.replace(
                        /^\s*([0-9]{3})\s*\-?([0-9]{3})\s*\-?([0-9]{2})\s*\-?([0-9]{2})$/,
                        '$1 $2 $3 $4'
                      )
                    }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row
      :class="{ active: DetailDescription }"
      class="row-bg"
      justify="end"
      type="flex"
    >
      <el-col :span="4">
        <div class="apartment-detail-description">
          <router-link
            :to="{ name: 'flat-detail', params: { id: item.id } }"
            class="apartment-detail-description"
          >
            <span>Детальний опис</span>
            <IconBase height="12" icon-color="#5ac2f2" width="12">
              <ArrowRight />
            </IconBase>
          </router-link>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import Eye from '../../icons/Eye'
import Boxes from '../../icons/Boxes'
import ApartmentState from '../../icons/ApartmentState'
import ApartmentHouse from '../../icons/ApartmentHouse'
import Square from '../../icons/Square'
import House from '../../icons/House'
import Gps from '../../icons/Gps'
import ApartmentSeller from '../ApartmentSeller'
import Share from '../../icons/Share'
import Link from '../../icons/Link'
import FacebookBlack from '../../icons/FacebookBlack'
import TelegramBlack from '../../icons/TelegramBlack'
import InstagramColored from '../../icons/InstagramColored'
import ViberColored from '../../icons/ViberColored'
import Heart from '../../icons/Heart'
import BorderedHeart from '../../icons/BorderedHeart'
import User from '../../icons/User'
import IconBase from '../../icons/IconBase'
import Phone from '../../icons/Phone'
import ArrowRight from '../../icons/ArrowRight'
import ApartmentSlider from '@/components/common/apartment_partials/ApartmentSlider'
import ApartmentPrise from '@/components/common/apartment_partials/ApartmentPrise'
import ApartmentInfo from '@/components/common/apartment_partials/ApartmentInfo'
import ApartmentSocial from '@/components/common/apartment_partials/ApartmentSocials'
import ApartmentSocialMobile from '@/components/common/apartment_partials/ApartmentSocialsMobile'
import AddToSelectedBtn from '@/components/common/apartment_partials/AddToSelectedBtn'
import { host } from '@/services/config'
import { mapGetters } from 'vuex'
import { Api } from '@/services/AxiosService'

export default {
  name: 'ApartmentPopUp',
  created() {
    if (this.$route.path.includes('flat-detail')) this.fetchFlatByID()
  },

  components: {
    AddToSelectedBtn,
    ApartmentSocial,
    ApartmentSocialMobile,
    ApartmentInfo,
    ApartmentPrise,
    ApartmentSlider,
    ArrowRight,
    Eye,
    Boxes,
    ApartmentState,
    ApartmentHouse,
    Square,
    House,
    Gps,
    ApartmentSeller,
    Share,
    Link,
    FacebookBlack,
    TelegramBlack,
    InstagramColored,
    ViberColored,
    Heart,
    IconBase,
    User,
    Phone,
    BorderedHeart,
  },
  props: {
    DetailDescription: Boolean,
    apartmentPopUpVisible: Boolean,
    item: Object,
  },
  computed: {
    ...mapGetters({
      favoriteFlats: 'getFavoriteFlatList',
    }),
  },
  data() {
    return {
      selectedActive: false,
      visiblePopOver: null,
      baseUrl: host,
      currentFlat: null,
    }
  },
  methods: {
    toggleFavorite() {
      const isFlatFavorite = !!this.favoriteFlats.find(
        (el) => el.id === this.item.id
      )
      if (!isFlatFavorite) {
        this.$store.dispatch('addToFavorite', this.item)
        return
      }
      this.$store.dispatch('deleteFromFavorite', this.item)
    },
    async fetchFlatByID() {
      try {
        const ID = this.$route.params.id
        const {
          data: { data },
        } = await Api.fetchFlatByID(ID)
        this.currentFlat = data
      } catch (e) {
        console.log('Error')
      }
    },
  },
}
</script>
